import { all, put, race, select, take, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import * as ClaimActionTypes from '@savgroup-front-common/core/domains/claims/actionTypes';
import { useLoginStore } from '@savgroup-front-common/core/domains/login/useLoginStore';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { getOrderByOwnerIdRequest } from '../../api/Owner/getOrderByOwnerId';
import { CLAIM_CANCELLED } from '../Claim/actionTypes';

import { loadOrders, ordersLoaded, ordersLoading } from './actionCreators';
import {
  LOAD_ORDERS,
  LOAD_ORDERS_DATA,
  MYORDERS_LOADED,
  MYORDERS_ON_ERRORS,
} from './actionTypes';
import {
  ordersSelectorItems,
  selectLoadOwnerOrdersWasLoaded,
} from './selectors';

export function* loadOrdersDataWorker({ payload } = { payload: {} }) {
  const forceRefresh = payload?.forceRefresh || false;

  yield all([
    put(LOAD_ORDERS_DATA.start({})),
    put(loadOrders({ forceRefresh })),
    race([
      take(MYORDERS_LOADED.BASE),
      take(MYORDERS_ON_ERRORS),
      take(LOAD_ORDERS.END),
    ]),
  ]);

  yield put(LOAD_ORDERS_DATA.success({}));
  yield put(LOAD_ORDERS_DATA.end({}));
}
export function* loadOrdersDataWatcher() {
  yield takeEvery([LOAD_ORDERS_DATA.BASE], loadOrdersDataWorker);
}

export function* loadOrdersForceRefreshWorker() {
  yield all([
    put(LOAD_ORDERS_DATA.start({})),
    put(loadOrders({ forceRefresh: true })),
    race([
      take(MYORDERS_LOADED.BASE),
      take(MYORDERS_ON_ERRORS),
      take(LOAD_ORDERS.END),
    ]),
  ]);

  yield put(LOAD_ORDERS_DATA.success({}));
  yield put(LOAD_ORDERS_DATA.end({}));
}
export function* loadOrdersForceRefreshWatcher() {
  yield takeEvery(
    [CLAIM_CANCELLED, ClaimActionTypes.DELETE_CLAIM_GROUP_BY_ID.END],
    loadOrdersForceRefreshWorker,
  );
}

export function* loadOrdersWorker({ payload }) {
  const forceRefresh = payload?.forceRefresh || false;
  const ownerId = useLoginStore.getState().login.id;
  const meta = { indexer: ownerId };

  const wasLoaded = yield select(selectLoadOwnerOrdersWasLoaded, { ownerId });

  if (!forceRefresh && wasLoaded) {
    const items = yield select(ordersSelectorItems);

    yield put(LOAD_ORDERS.end(meta));
    yield put(ordersLoaded({ items }));

    return;
  }

  yield put(ordersLoading());

  const response = yield executeSagaRequest(
    LOAD_ORDERS,
    getOrderByOwnerIdRequest({ ownerId }),
    meta,
  );

  yield put(ordersLoaded({ items: response?.payload?.value || [] }));

  yield put(LOAD_ORDERS.end(meta));
}
export function* loadOrdersWatcher() {
  yield takeEvery(LOAD_ORDERS.BASE, loadOrdersWorker);
}

export default function* ordersSaga() {
  try {
    yield all([
      loadOrdersDataWatcher(),
      loadOrdersWatcher(),
      loadOrdersForceRefreshWatcher(),
    ]);
  } catch (error) {
    logCritical(error);
  }
}
